<template>
    <div>
        <nav-breadcrumb :menu="[{label: '材料打印清单'}]"/>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :is-pagination-show="false"
                :filters.sync="filters"
                :actions="actions"
            />
        </div>
        <el-dialog v-if="dialogVisible" title="变更代理人"
                   :visible.sync="dialogVisible"
                   width="60%">
            <el-form :model="dataForm" :rules="{}" ref="dataForm" label-width="150px">
                <el-row>
                    <el-col>
                        <el-form-item label="是否变更代理人：" prop="taxFactor">
                            <el-checkbox v-model="dataForm.checked" false-label="N" true-label="Y"  style="width: 35%"></el-checkbox>
                        </el-form-item>
                        <el-form-item label="代理人：" prop="taxFactor">
                            <el-input v-model="dataForm.proxyPersonName"  style="width: 35%" :disabled="dataForm.checked=='N'" ></el-input>
                        </el-form-item>
                        <el-form-item label="代理人身份证：" prop="taxFactor">
                            <el-input v-model="dataForm.proxyPersonIC"  style="width: 35%" :disabled="dataForm.checked=='N'"></el-input>
                        </el-form-item>
                        <el-form-item label="代理人电话：" prop="taxFactor">
                            <el-input v-model="dataForm.proxyPersonContactNo" style="width: 35%" :disabled="dataForm.checked=='N'"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="exportPdf2">打印</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    export default {
        name: "CustomerPrintDetail",
        data(){
            return{
                transactionId: this.$route.query['transactionId']||'',
                applicationId: this.$route.query['applicationId']||'',
                dataForm:{
                    proxyPersonName:'',
                    proxyPersonIC:'',
                    proxyPersonContactNo:'',
                    checked:'N'

                },
                dialogVisible:false,
                proxyPersonName:'',
                proxyPersonIC:'',
                proxyPersonContactNo:'',
                tableData: {
                    count: 0,
                    data: [

                        {
                            name:'表三',
                            url:'',
                            type:'pdf'

                        },
                        {
                            name:'委托书',
                            url:'',
                            type:'pdf'
                        },
                        {
                            name:'结清证明',
                            url:'JQHW',
                            type:'pdf'
                        },

                    ]
                },
                page: 1,
                pageSize: 20,
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '文件名称',
                        field: 'name'
                    },
                    {
                        label: '操作',
                        opts: [
                            {
                                class: 'el-icon-download',
                                name: '下载',
                                clickHandler: (index, row)=>{
                                    if(row.name=='表三'||row.name=='委托书'){
                                        this.dialogVisible = true
                                        this.dataForm.proxyPersonName = this.proxyPersonName
                                        this.dataForm.proxyPersonContactNo = this.proxyPersonContactNo
                                        this.dataForm.proxyPersonIC = this.proxyPersonIC
                                        this.dataForm.url = row.url
                                        this.dataForm.type = row.type
                                    }else{
                                        this.exportPdf(index, row)
                                    }
                                },
                                conditions: row=> {
                                    return row.url !==''

                                }
                            },
                        ]
                    },

                ],

                actions: [
                ],
                filters: {
                    labelWidth: '150px',
                    form: {

                    },
                    columns: [


                    ],
                    onSubmit:()=>{

                    }
                }
            }
        },
        mounted() {
            this.getFinancingFang()
            this.getHisWarrantTx()
        },
        methods:{
            getFinancingFang : function () {
                xhr.getFinancingFang({
                    'fi.transactionId': this.$route.query['transactionId']
                }, res=>{
                    try{
                        if(res.data.status == 'success') {

                            const customerDetail = res.data.data
                            if(customerDetail.t__regionId=='JSWXWX'){
                                this.tableData.data[0].url='SQSHW'
                                this.tableData.data[1].url='WTSHW'
                            }else if(customerDetail.t__regionId=='JSWXJY'){
                                this.tableData.data[0].url='SQSJYHW'
                                this.tableData.data[0].name='抵押注销申请表'
                                this.tableData.data[1].url='WTSJYHW'
                            }
                            else if(customerDetail.t__regionId=='JSCZCZ' ||customerDetail.t__regionId=='JSCZWJ'){
                                this.tableData.data[0].url='SQSCZHW'
                                this.tableData.data[0].name='抵押注销申请书'
                                this.tableData.data[1].url='WTSCZHW'
                            }

                        }
                    }catch(e){}
                })
            },
            getHisWarrantTx : function () {
                xhr.getHisWarrantTx({
                    't.applicationId': this.$route.query['applicationId']
                }, res=>{
                    try{
                        if(res.data.status == 'success') {
                            const customerDetail = res.data.data
                            this.proxyPersonName = customerDetail.t__proxyPersonName
                            this.proxyPersonContactNo = customerDetail.t__proxyPersonContactNo
                            this.proxyPersonIC = customerDetail.t__proxyPersonIC

                        }
                    }catch(e){}
                })
            },
            exportPdf: function (index, row) {
                try {

                    if(row.type=='pdf'){
                        window.open('/extended/markup/t/docs/financing/'+row.url+'.'+row.type+'?w.applicationId='+this.$route.query['applicationId'])
                    }else {
                       // window.open('/ix/fang/financing/'+row.url+'.'+row.type+'?transactionId='+this.$route.query['transactionId'])
                    }
                }
                catch (e) {

                }
            },
            exportPdf2: function () {
                try {
                    if(this.dataForm.checked=='Y'){
                        window.open('/extended/markup/t/docs/financing/'+this.dataForm.url+'.'+this.dataForm.type+'?w.applicationId='+this.$route.query['applicationId']
                            +'&&proxyPersonName='+this.dataForm.proxyPersonName
                            +'&&proxyPersonContactNo='+this.dataForm.proxyPersonContactNo
                            +'&&proxyPersonIC='+this.dataForm.proxyPersonIC)
                    }else {
                        window.open('/extended/markup/t/docs/financing/'+this.dataForm.url+'.'+this.dataForm.type+'?w.applicationId='+this.$route.query['applicationId'])
                    }
                    this.dialogVisible =false
                    this.dataForm = {
                        proxyPersonName:'',
                        proxyPersonIC:'',
                        proxyPersonContactNo:'',
                        checked:'N'

                    }


                }
                catch (e) {

                }
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/HisWarrantPrint.vue